/**
 * Gets the pawns that should be visible based on the game mode and active players
 * 
 * @param {Array} pawns - All pawns in the game
 * @param {Array} players - All players in the game
 * @param {boolean} is2PlayerMode - Whether the game is in 2-player mode
 * @returns {Array} - The pawns that should be visible
 */
export const getVisiblePawns = (pawns, players, is2PlayerMode) => {
    if (!is2PlayerMode || !players.length || !pawns.length) {
        return pawns;
    }
    
    // In 2-player mode, only show pawns for the two active players
    const activePlayerColors = players
        .filter(player => player.name !== '...')
        .map(player => player.color);
        
    return pawns.filter(pawn => activePlayerColors.includes(pawn.color));
};

/**
 * Gets the players that should be visible based on the game mode and active players
 * 
 * @param {Array} players - All players in the game
 * @param {string} currentPlayerColor - The color of the current player
 * @param {boolean} is2PlayerMode - Whether the game is in 2-player mode
 * @returns {Array} - The players that should be visible
 */
export const getVisiblePlayers = (players, currentPlayerColor, is2PlayerMode, maxPlayers = 4) => {
    if (!is2PlayerMode) {
        // In regular mode, show all players up to maxPlayers
        return players.slice(0, maxPlayers);
    }
    
    // In 2-player mode, only show the active players
    const activePlayers = players.filter(player => player.name !== '...');
    
    // If we have 2 active players, show them at the top and bottom positions
    if (activePlayers.length === 2) {
        // Map the players to the first and third positions (top and bottom)
        const positionedPlayers = [null, null, null, null];
        
        // Current player should be at bottom (index 2)
        const currentPlayerIndex = activePlayers.findIndex(
            player => player.color === currentPlayerColor
        );
        
        if (currentPlayerIndex !== -1) {
            const otherPlayerIndex = currentPlayerIndex === 0 ? 1 : 0;
            
            // Current player at bottom (index 2)
            positionedPlayers[2] = activePlayers[currentPlayerIndex];
            
            // Other player at top (index 0)
            positionedPlayers[0] = activePlayers[otherPlayerIndex];
            
            return positionedPlayers;
        }
    }
    
    // Fallback to default
    return players.slice(0, maxPlayers);
};
